import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { z } from 'zod';
import { DATE_FORMAT, DATE_TIME_FORMAT } from './const/date';

dayjs.extend(customParseFormat);

export function registrosSchema<Schema extends z.ZodType>(schema: Schema) {
    return z.object({
        registros: schema.array(),
        status: z.literal('sucesso'),
        total_registros: z.number().optional(),
    });
}

export const NotNullStringSchema = z
    .string()
    .nullable()
    .transform((value) => value ?? '');

export const NotNullNumberSchema = z
    .number()
    .nullable()
    .transform((value) => value ?? 0);

export const DateTimeSchema = z
    .string()
    .refine((value) => dayjs(value, DATE_TIME_FORMAT, true).isValid(), {
        message: 'Data e hora inválidas',
    });

export const DateSchema = z.string().refine((value) => dayjs(value, DATE_FORMAT, true).isValid(), {
    message: 'Data inválida',
});

export const StringToIdpkSchema = z.string().transform(Number).pipe(z.int().positive());
